import StopIndex from './StopIndex';

export { type StopIndexProps } from './StopIndex';
export default StopIndex;
